import * as angular from "angular";
import {IController} from "angular";

export class BringozColorBoxComponent implements IController {
  color: string;
  isSelected?: boolean;
  onSelect: Function;

  constructor() {
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozColorBox', {
    bindings: {
      color: '<',
      isSelected: '<?',
      onSelect: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-color-box/bringoz-color-box.html',
    controller: BringozColorBoxComponent
  });
